module.exports = __webpack_public_path__ + "images/illustrations/illustration-rocketman-a7dbfa9132d085a080262df170c95329.webp";